import { gql, useMutation } from '@apollo/client';

export const RECORD_ONBOARDING_COURSE_OFFER = gql`
  mutation RecordOnboardingCourseOffer($event: String!, $experience: String) {
    recordOnboardingCourseOffer(event: $event, experience: $experience) {
      id
      onboarding_experience
    }
  }
`;

export function useRecordOnboardingCourseOffer() {
  return useMutation(RECORD_ONBOARDING_COURSE_OFFER);
}
